import { render, staticRenderFns } from "./forbidDialog.vue?vue&type=template&id=10d3619c"
import script from "./forbidDialog.vue?vue&type=script&lang=js"
export * from "./forbidDialog.vue?vue&type=script&lang=js"
import style0 from "./forbidDialog.vue?vue&type=style&index=0&id=10d3619c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports